var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.333 17.833V2.167a.5.5 0 0 1 .5-.5h9.71a.5.5 0 0 1 .353.146l2.624 2.624a.5.5 0 0 1 .146.353v13.043a.5.5 0 0 1-.5.5H3.833a.5.5 0 0 1-.5-.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8.863 8.68.866-1.837a.297.297 0 0 1 .543 0l.866 1.836 1.936.297c.249.038.348.357.168.54l-1.401 1.428.33 2.018c.043.259-.217.457-.44.334l-1.73-.953-1.732.953c-.222.123-.482-.075-.44-.334l.33-2.018-1.4-1.427c-.18-.184-.08-.503.167-.541l1.937-.297ZM13.333 1.667V4.5a.5.5 0 0 0 .5.5h2.833"
}))));
export default SvgStarDocument;